<template>
  <div>
    <div class="float-left">
      <div v-if="datosActividad.estadoVigencia">
        <div v-if="existeTarea">
          <b-button class="small px-3" variant="outline-primary" @click="verModalEditarTarea=true, archivoSeleccionado=null, mensajeAdjunto='', nuevoMensaje=''">Editar Tarea <span v-if="datosTarea.linkAdjunto"><i class="fas fa-paperclip"></i></span></b-button>
        </div>
        <div v-else>
          <b-button class="small px-3" variant="success" @click="inhabilitaBotonCrear=true, crearTarea()" :disabled="inhabilitaBotonCrear">Crear Tarea</b-button>
        </div>
      </div>
      <div v-else>
        <b-button class="small px-2" variant="outline-secondary">Tarea Cerrada <span v-if="datosTarea.linkAdjunto"><i class="fas fa-paperclip"></i></span></b-button>
      </div>
    </div>
    <div class="float-right mx-2"><b-button class="small" variant="primary" @click="verModalEvaluacion=true">Ver</b-button></div>
    <div class="float-right" v-if="datosTarea.nota > 0"><b-button class="small" variant="light"> {{ datosTarea.nota }} </b-button></div>


    <!-- MODAL EDITAR TAREA -->
    <b-modal scrollable size="xl" :title="'Editar Tarea [#'+datosTarea.id+']'" header-bg-variant="primary" header-text-variant="light" v-model="verModalEditarTarea">
      <b-card-text>
        <div class="container">
          <div v-if="!esperaCarga">
            <b-row>
              <b-col lg="12">
                <b-form-group label="Titulo de la Actividad:" label-for="titulo">
                  <b-form-input type="text" id="titulo" v-model="datosActividad.tituloActividad" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
              </b-col>
            </b-row>
            <b-card class="mt-3">
              <div v-if="datosTarea.adjunto===null || datosTarea.adjunto===''">
                <p class="mt-0 mb-1"><strong> Adjuntar un archivo:</strong><span class="text-muted"> (El tamaño maximo permitido es de 20 Mb)</span></p>
                <b-form-file v-model="archivoSeleccionado" placeholder="Seleccione un archivo..." :file-name-formatter="validar"></b-form-file>
                <div class="mt-3" v-if="archivoSeleccionado">
                  <b-button variant="danger" @click="archivoSeleccionado=null, mensajeAdjunto=''">
                    Quitar archivo seleccionado
                  </b-button>
                </div>
                <div :class="clase"><h4>{{ mensajeAdjunto }}</h4></div>
              </div>
              <div v-else>
                <div>Archivo adjunto:<br>{{ datosTarea.adjunto }}
                  <a class="btn btn-outline-primary btn-sm ml-5" :href="datosTarea.linkAdjunto" target="_blank">Descargar</a>
                  <b-button variant="outline-danger" size="sm" class="ml-2" @click="eliminarAdjunto()">Eliminar</b-button>
                </div>
              </div>
            </b-card>
            <b-row class="mt-3">
                <b-col lg="12">
                    <label>Mensajes:</label>
                    <b-form-textarea v-model="datosTarea.mensajes" placeholder="Sin Mensajes" rows="8" disabled></b-form-textarea>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-3">
              <b-col lg="12">
                <b-input-group>
                  <template v-slot:prepend>
                    <b-input-group-text><strong class="text-primary"><i class="fas fa-comment-dots"></i></strong></b-input-group-text>
                  </template>
                  <b-form-input v-model="nuevoMensaje" placeholder="Enviar un mensaje al docente..."></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
          <div class="text-center" v-else>
            <h1 class="my-5"><b-icon icon="arrow-clockwise" animation="spin-pulse" font-scale="4"></b-icon></h1>
          </div>
        </div>
      </b-card-text>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="px-5" variant="success" @click="actualizarTarea()" :disabled="inhabilitaBotonEditar"> Actualizar la Tarea</b-button>
        <b-button class="px-5" variant="outline-danger" @click="cancel()"> Cancelar </b-button>
      </template>
    </b-modal>

    <b-modal scrollable title="Evaluación de la Tarea" header-bg-variant="primary" header-text-variant="light" v-model="verModalEvaluacion">
      <b-card-text class="text-center">
        <div>ACTIVIDAD:<br> <strong>{{ datosActividad.tituloActividad }}</strong></div>
        <hr>
        FECHA DE LA TAREA: {{ this.fechaTarea }}
        <hr>
        <div v-if="existeTarea">
          <div v-if="datosTarea.revisada">
            <div v-if="datosTarea.nota != null" class="text-success my-2">
              <h2>Calificación obtenida: {{ datosTarea.nota }}</h2>
            </div>
            <div v-else class="text-primary"><h2 class="my-2 mx-3">Aún no se le ha asignado una calificación, consulte en otro momento.</h2></div>
          </div>
          <div v-else class="text-warning"><h2 class="my-2 mx-3">La tarea está en proceso de revisión, consulte en otro momento.</h2></div>
        </div>
        <div v-else class="text-danger">
          <h2 class="my-2 mx-3">El estudiante no ha enviado la tarea para su evaluación.</h2>
        </div>
        <hr>
        <b-row class="mt-2">
            <b-col lg="12">
                <label>MENSAJES:</label>
                <b-form-textarea v-model="datosTarea.mensajes" placeholder="Sin Mensajes" rows="8" disabled></b-form-textarea>
            </b-col>
        </b-row>
      </b-card-text>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="px-5" variant="primary" @click="cancel()"> Cerrar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

  export default {
    name: 'TareaActividad',
      props: {
        datosActividad: Object
      },
    data () {
      return {
        inhabilitaBotonCrear: false,
        datosTarea: {},
        existeTarea: false,
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {},
        verModalEditarTarea: false,
        archivoSeleccionado: null,
        mensajeAdjunto: '',
        nuevoMensaje: '',
        inhabilitaBotonEditar: false,
        esperaCarga: false,
        datosActualizarTarea: {},
        archivoAdjuntado: null,
        datosNuevaTarea: {},
        fechaTarea: '',
        verModalEvaluacion: false,
        clase: '',
      }
    },
    methods: {
      //OK
      async crearTarea() {
        this.datosNuevaTarea.id_asignatura_docente = this.datosActividad.idAsignaturaDocente
        this.datosNuevaTarea.id_matricula = this.$store.state.idMatriculaUsuario
        this.datosNuevaTarea.id_actividad = this.datosActividad.idActividad
        this.datosNuevaTarea.bd = this.$store.state.bdColegio
        await axios
        .post(CONFIG.ROOT_PATH + "tareas", JSON.stringify(this.datosNuevaTarea), { headers: {"Content-Type": "application/json; charset=utf-8" }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
        this.consultarTarea()
      },
      //OK
      async actualizarTarea() {
        let fechaAhora = new Date()
        let ano = fechaAhora.getFullYear()
        let mes = fechaAhora.getMonth() + 1
        let dia = fechaAhora.getDate()
        this.inhabilitaBotonEditar = true
        this.esperaCarga = true
        this.datosActualizarTarea.id = this.datosTarea.id
        this.datosActualizarTarea.contenido = this.editorData
        this.datosActualizarTarea.mensajes = this.datosTarea.mensajes
        this.datosActualizarTarea.sinleerDocente = this.datosTarea.mensajes_sin_leer_docente
        if (this.nuevoMensaje != ''){
          this.datosActualizarTarea.mensajes = '--- ' + this.$store.state.nombresUsuario + ' ' + this.$store.state.apellidosUsuario + ' el ' + fechaAhora.toLocaleDateString() + ' ' + fechaAhora.toLocaleTimeString() + '\n' + this.nuevoMensaje + '\n\n' + this.datosTarea.mensajes
          this.datosActualizarTarea.sinleerDocente += 1
        }
        this.datosActualizarTarea.bd = this.$store.state.bdColegio
        this.datosActualizarTarea.fecha_tarea = ano + '-' + mes + '-' + dia + ' ' + fechaAhora.toLocaleTimeString()
        this.datosActualizarTarea.adjunto = null
        this.datosActualizarTarea.fecha_adjunto = null
        if (this.archivoSeleccionado != null && this.archivoSeleccionado != '') {
          this.archivoAdjuntado = null
          await this.submitFile()
          if (this.archivoAdjuntado != null) {
            this.datosActualizarTarea.adjunto = this.archivoAdjuntado
            this.datosActualizarTarea.fecha_adjunto = ano + '-' + mes + '-' + dia + ' ' + fechaAhora.toLocaleTimeString()
          } else {
            alert('Se presentó una falla en la conexión y no se cargo el archivo. Por favor revise su conexión a internet e intente nuevamente adjuntar el archivo.')
          }
        }
        await axios
        .put(CONFIG.ROOT_PATH + "tareas/estudiante", JSON.stringify(this.datosActualizarTarea),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
        .then(response => {
          if (response.data.error){
              this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
              this.mensajeEmergente("success","Mensaje",response.data.mensaje)
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
        this.consultarTarea()
        setTimeout(() => {
          this.inhabilitaBotonEditar = false
          this.verModalEditarTarea = false
          this.esperaCarga = false
        }, 3000)
      },
      //OK
      async eliminarAdjunto() {
        this.datosTarea.adjunto = null
        this.datosTarea.linkAdjunto = null
        let archivoAdjunto = { id: this.datosTarea.id, bd: this.$store.state.bdColegio, archivo: null }
        await axios
        .put(CONFIG.ROOT_PATH + "adjuntos/tarea", JSON.stringify(archivoAdjunto),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else {
            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
      },
      //OK
      validar(archivo) {
        if (archivo[0].name != '' && archivo[0].name != null) {
          if (archivo[0].size > 20880000){
            this.inhabilitaBotonCrear = true
            this.inhabilitaBotonEditar = true
            this.mensajeAdjunto = 'El archivo seleccionado no se puede adjuntar ya que es demasiado grande.'
            this.clase = 'mt-3 text-danger'
          } else {
            this.inhabilitaBotonCrear = false
            this.inhabilitaBotonEditar = false
            this.mensajeAdjunto = 'El tamaño del archivo seleccionado es válido.'
            this.clase = 'mt-3 text-success'
          }
          return archivo[0].name
        }
      },
      //OK
      async submitFile(){
        let formData = new FormData()
        formData.append('file', this.archivoSeleccionado)
        await axios
        .post(CONFIG.ROOT_PATH + 'adjuntartarea/' + this.$store.state.bdColegio, formData, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then(response => {
          if(response.data.error) {
            this.archivoAdjuntado = null
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else {
            this.archivoAdjuntado = response.data.mensaje
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      //OK
      async consultarTarea() {
        await axios
        .get(CONFIG.ROOT_PATH + "tarea/actividad/estudiante", { params: { bd: this.$store.state.bdColegio, idmatricula: this.$store.state.idMatriculaUsuario, idactividad: this.datosActividad.idActividad }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            if (response.data.datos != 0){
              this.datosTarea = response.data.datos
              this.existeTarea = true
              this.editorData = this.datosTarea.contenido
              if (this.datosTarea.adjunto == null || this.datosTarea.adjunto == '') {
                this.datosTarea.linkAdjunto = null
              } else {
                this.datosTarea.linkAdjunto = 'https://sised.com.co/APISised/colegios/' + this.$store.state.bdColegio + '/descargas/aulas/' + this.datosTarea.adjunto
              }
              let fecha = new Date(this.datosTarea.fecha_tarea)
              this.fechaTarea = fecha.toLocaleDateString() + ' a las ' + fecha.toLocaleTimeString()
            } else {
              this.datosTarea = {}
              this.fechaTarea = ''
              this.existeTarea = false
            }
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.consultarTarea()
    },
    computed: {
    }
  }
</script>
